import { Controller } from "@hotwired/stimulus"

// Onboarding welcome beat: Jane's intro greeting shows first, then — after a
// short typing indicator — the question card fades in, so the user never has to
// click through the greeting. Plays once per browser session; a reload or
// return visit just shows the card immediately.
const REVEAL_DELAY_MS = 1500

export default class extends Controller {
    connect() {
        const intro = this.element.querySelector("[data-onboarding-intro]")
        const card = this.element.querySelector(".assistant-ask-card")
        if (!intro || !card) return

        const key = `onboarding-intro-revealed:${card.dataset.conversationId || "x"}`
        if (this._seen(key)) {
            // Cached/return render — make sure nothing is left hidden.
            card.classList.remove("onboarding-reveal", "is-hidden")
            return
        }
        this._mark(key)

        card.classList.add("onboarding-reveal", "is-hidden")
        const typing = this._buildTypingBubble()
        intro.after(typing)

        this._timer = setTimeout(() => {
            typing.remove()
            card.classList.remove("is-hidden")
            requestAnimationFrame(() => card.classList.add("is-in"))
            card.scrollIntoView({ behavior: "smooth", block: "nearest" })
        }, REVEAL_DELAY_MS)
    }

    disconnect() {
        if (this._timer) clearTimeout(this._timer)
    }

    _buildTypingBubble() {
        const bubble = document.createElement("div")
        bubble.className = "assistant-bubble assistant-bubble-assistant"
        bubble.setAttribute("data-onboarding-typing", "true")
        const indicator = document.createElement("div")
        indicator.className = "typing-indicator"
        indicator.setAttribute("role", "status")
        indicator.setAttribute("aria-label", "Typing…")
        for (let i = 0; i < 3; i++) {
            const dot = document.createElement("span")
            dot.className = "typing-indicator-dot"
            indicator.appendChild(dot)
        }
        bubble.appendChild(indicator)
        return bubble
    }

    _seen(key) {
        try { return sessionStorage.getItem(key) === "1" } catch { return false }
    }

    _mark(key) {
        try { sessionStorage.setItem(key, "1") } catch { /* ignore */ }
    }
}
